import Modernizr from 'modernizr';
import { Observable, from, fromEvent, merge } from 'rxjs';
import { take } from 'rxjs/operators';

export namespace Fullscreen {
  export function toggleFullscreen(element?: any) {
    const fullscreenElement = getFullscreenElement();
    fullscreenElement === null ? requestFullscreen(element) : exitFullscreen();
  }

  // Request fullscreen
  export function requestFullscreen(element?: any) {
    if (checkFullscreenSupport()) {
      if (!element) {
        element = document.body;
      }

      const fn = Modernizr.prefixed('requestFullscreen', element);
      fn();
    }
  }

  // Exit fullscreen
  export function exitFullscreen() {
    if (checkFullscreenSupport()) {
      const fn = Modernizr.prefixed('exitFullscreen', document);
      fn();
    }
  }

  // Is fullscreen supported by the browser, and the potential parent iframe
  export function canFullscreen(): boolean {
    return Modernizr.fullscreen && Modernizr.prefixed('fullscreenEnabled', document);
  }

  // More verbose canFullscreen
  export function checkFullscreenSupport(): boolean {
    if (canFullscreen()) {
      return true;
    } else {
      console.warn('Fullscreen is not enabled');
      return false;
    }
  }

  // Return the current fullscreen element, or null
  export function getFullscreenElement() {
    return Modernizr.prefixed('fullscreenElement', document);
  }

  // Utility function to check if we're in full screen
  export function isFullscreen() {
    return getFullscreenElement() != null;
  }

  export function onFullscreenChange(): Observable<Event> {
    const events$ = 'mozfullscreenchange webkitfullscreenchange MSFullscreenChange fullscreenchange'
      .split(' ')
      .map((event) => {
        return fromEvent(document.body, event);
      });

    return merge(...events$);
  }
}
